import { Link } from "react-router-dom";
import Layout from "@/components/Layout";

export default function NotFound() {
  return (
    <Layout>
      <section
        data-testid="page-not-found"
        className="relative pt-32 pb-32 min-h-[70vh] flex items-center justify-center"
      >
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[900px] h-[500px] opacity-[0.07] blur-3xl"
               style={{ background: "radial-gradient(circle,#ff5a00,transparent 60%)" }} />
        </div>
        <div className="relative z-10 max-w-[720px] mx-auto px-6 text-center">
          <p className="font-mono text-[11px] uppercase tracking-[0.45em] text-[#ff5a00]">
            404 · The forge does not open this door
          </p>
          <h1
            data-testid="not-found-headline"
            className="font-display uppercase leading-[0.92] mt-6 text-[#ededed]"
            style={{ fontSize: "clamp(3rem, 8vw, 6rem)", letterSpacing: "-0.005em" }}
          >
            Nothing here.
            <br />
            <span className="italic text-[#ff5a00]">Try the front door.</span>
          </h1>
          <p className="font-body text-base sm:text-lg text-[#a1a1aa] mt-8 max-w-xl mx-auto leading-relaxed">
            You reached a URL the studio does not serve. No harm done.
          </p>
          <div className="mt-10 flex flex-wrap gap-4 justify-center">
            <Link
              to="/"
              data-testid="not-found-home"
              className="font-mono text-[11px] uppercase tracking-[0.32em] bg-[#ff5a00] text-[#050505] px-6 py-3 hover:bg-[#ff8f00] transition-colors"
            >
              Back to the forge
            </Link>
            <Link
              to="/products"
              className="font-mono text-[11px] uppercase tracking-[0.32em] text-[#ededed] border border-[#27272a] px-6 py-3 hover:border-[#ff5a00] hover:text-[#ff5a00] transition-colors"
            >
              See the products
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}
